module.exports = __webpack_public_path__ + "static/media/3-4.9fdb442b.png";